import styled from "styled-components";

export const ContainerDataRequestItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  font-weight: 500;

  width: 100%;
  padding: 10px;
`;

export const ContainerCheckBox = styled.div`
display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 10px;
`